var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Header',[_c('v-row',{staticClass:"app-header__panel px-3 pt-4",attrs:{"justify":"space-between","align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',{staticClass:"app-header__panel-title text-center"},[_vm._v(" Hola "+_vm._s(_vm.fullname)+"..!! ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }